import React from 'react'
import { Skeleton as MSkeleton, SkeletonProps as MSkeletonProps } from '@material-ui/lab'
import Card from 'atoms/surfaces/card/Card'

export type SkeletonProps = MSkeletonProps & {
  card?: boolean
}

export default function Skeleton ({ card, animation, ...props }: SkeletonProps) {
  const skeleton = (
    <MSkeleton
      {...props}
      animation={animation || 'wave'}
    />
  )

  if (!card) {
    return skeleton
  }

  return (
    <Card>
      {skeleton}
    </Card>
  )
}
